import React from 'react';
import { motion } from 'framer-motion';
import { Maximize, GraduationCap, Clock, RefreshCw, Layers, Coins } from 'lucide-react';
const OBJECTIONS = [{
  icon: Maximize,
  question: '"No tengo espacio"',
  answer: 'Funciona en patio, terraza, balcón o macetas. El sistema se adapta a cualquier superficie disponible.'
}, {
  icon: GraduationCap,
  question: '"No tengo experiencia"',
  answer: 'Está diseñado para principiantes, con paso a paso real. Empezás desde cero sin conocimientos previos.'
}, {
  icon: Clock,
  question: '"No tengo mucho tiempo"',
  answer: 'El sistema baja tu carga mental y te da rutinas simples. No necesitás horas al día para mantenerlo.'
}, {
  icon: RefreshCw,
  question: '"Ya intenté y me fue mal"',
  answer: 'Justamente: porque te faltaba estructura. Con el sistema, los errores se eliminan antes de que pasen.'
}, {
  icon: Layers,
  question: '"¿No será muy básico?"',
  answer: 'El sistema va desde cero hasta producción avanzada y emprendimiento. Elegís el nivel que necesitás con los combos.'
}, {
  icon: Coins,
  question: '"¿Vale la pena por ese precio?"',
  answer: 'Un kilo de tomates en la verdulería sale más de ARS 3.000. Con este sistema, producís kilos por temporada. Se paga solo en la primera cosecha.'
}];
export function ObjectionsSection() {
  return <section className="py-14 px-4 bg-black" data-id="element-165">
      <div className="max-w-4xl mx-auto" data-id="element-166">
        <div className="text-center mb-8" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-168">
            ¿Tenés dudas? Las respondemos.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-169">
          {OBJECTIONS.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-zinc-900 border-l-4 border-green-500 border-t border-r border-b border-zinc-800 p-4 rounded-r-xl flex items-start gap-4" data-id="element-170">
              <div className="bg-zinc-950 p-2.5 rounded-lg shrink-0 border border-zinc-800 mt-0.5" data-id="element-171">
                <item.icon className="w-5 h-5 text-green-500" data-id="element-172" />
              </div>
              <div data-id="element-173">
                <p className="text-green-400 font-bold text-lg mb-1.5" data-id="element-174">
                  {item.question}
                </p>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-175">
                  {item.answer}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}